<template>
    <div class=" box-sizing">
        <div class="bold fs20 pad "><div class="pad">实名认证</div></div>
        <div class="pad lr10">

            <label class="c-tip" onclick="window.location='/login'">
                <el-alert  title="温馨提示：请完成实名认证，否则短链接无法正常稳定使用" type="warning" show-icon :closable="false"></el-alert>
            </label>
        </div>

        <div class="flex jus-center" v-if="info.status==1">
            <div class="pad20" style="width:300px;">
                <div class="flex-row item-center mb15">
                    <img src="../../assets/images/ok.png"  class="pic-50"/>
                    <div class="ml10 fs20">恭喜你！您已完成认证! </div>
                </div>
                <div class="pad linehei1_5 fs14 border-gray bg_gray radius-5" v-if="info.type==1" >
                    认证类型：个人 <br>
                    姓名： {{info.user_name}}<br>
                    身份证： {{info.id_number}}<br>
                </div>
                <div class="pad linehei1_5 fs14 border-gray bg_gray radius-5" v-if="info.type==2">
                    认证类型：企业 <br>
                    公司名称： {{info.company_name}}<br>
                </div>
            </div>
        </div>
        <div class="flex jus-center" v-if="info.status==0">
            <div class="pad20" style="width:300px;">
                <div class="flex-row item-center mb15">
                    <img src="../../assets/images/wait.png"  class="pic-50"/>
                    <div class="ml10 fs20">资料审核中 </div>
                </div>
                <div class="pad linehei1_5 fs14 border-gray bg_gray radius-5" v-if="info.type==1" >
                    认证类型：个人 <br>
                    姓名： {{info.user_name}}<br>
                    身份证： {{info.id_number}}<br>
                </div>
                <div class="pad linehei1_5 fs14 border-gray bg_gray radius-5" v-if="info.type==2">
                    认证类型：企业 <br>
                    公司名称： {{info.company_name}}<br>
                </div>
            </div>
        </div>
        <div class="flex jus-center" v-if="info.status==2">
            <div class="pad20" style="width:300px;">
                <div class="flex-row item-center mb15">
                    <img src="../../assets/images/wait.png"  class="pic-50"/>
                    <div class="ml10 fs20">审核失败 </div>
                </div>
                <div class="pad linehei1_5 fs14 border-gray bg_gray radius-5"  >
                    失败原因：{{info.audit_mark}}
                </div>

            </div>
        </div>

        <div class="pad20 fs16" style="width:600px;" v-if="info.status!=1 && !info.id">
            <div class="flex-row pad item-center">
                <div class="w150px right_txt"> 类型：</div>
                <div><input type="radio" v-model="info.type" name="type" value="1" :checked="info.type==1"/>个人   <input type="radio" v-model="info.type" name="type" value="2" :checked="info.type==2"/>企业</div>
            </div>

            <div v-show="info.type==2">
                <div class="flex-row pad item-center mt15">
                    <div class="w150px right_txt"> 企业单位名称：</div>
                    <div><input v-model="info.company_name" type="text" placeholder="请输入主体名称" style="width:300px;"/></div>
                </div>
                <div class="flex-row pad item-center mt15">
                    <div class="w150px right_txt"> 营业执照：</div>
                    <div class="flex-row item-center">
                        <img :src="info.license_img+''" class="pic-50" v-if="info.license_img" />
                        <el-upload
                                action=""
                                :http-request="upload_cer"
                                :show-file-list="false"
                                accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF"
                                :on-success="null">
                            <span class="border-gray pad510 bg_gray_eee radius-5 fs12 ml10">+点击上传</span>
                            <span class="fs12 ml10">只能上传图片文件，且不超过5mb</span>
                        </el-upload>
                    </div>
                </div>
            </div>

            <div class="flex-row pad item-center mt15">
                <div class="w150px right_txt"> <span v-if="type==2">负责人</span>姓名：</div>
                <div><input v-model="info.user_name" class="" type="text" placeholder="请输入姓名" /></div>
            </div>
            <div class="flex-row pad item-center mt15">
                <div class="w150px right_txt"> 手机号：</div>
                <div><input v-model="info.mobile" type="text" placeholder="请输入手机号" /></div>
            </div>
            <div class="flex-row pad item-center mt15">
                <div class="w150px right_txt"> 验证码：</div>
                <div>
                    <input v-model="code"  type="text" placeholder="" style="width:80px;"/>
                    <span v-if="showText==true" class="bg_blue pad510 fs12 radius-5 ml10" @click="sendCode">发送验证码</span>
                    <span v-else class="bg_blue pad510 fs12 radius-5 ml10">{{second}}s重新发送</span>
                </div>
            </div>
            <div class="flex-row pad item-center mt15">
                <div class="w150px right_txt"> 身份证照片：</div>
                <div class="flex-row item-center">

                    <img :src="info.id_img+''" class="pic-50" v-if="info.id_img" />
                    <el-upload
                            action=""
                            :http-request="upload_id"
                            :show-file-list="false"
                            accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF"
                            >
                        <span class="border-gray pad510 bg_gray_eee radius-5 fs12">+点击上传</span>
                        <span class="fs12 ml10">只能上传图片文件，且不超过5mb</span>
                    </el-upload>
                </div>
            </div>
            <div class="flex-row pad item-center mt15">
                <div class="w150px right_txt"> 身份证号码：</div>
                <div><input  v-model="info.id_number" type="text" placeholder="请输入身份证号码" /></div>
            </div>

            <div class="flex-row pad item-center">
                <div class="w150px right_txt"> </div>
                <el-button class="w200px" type="primary" @click="submit">确定</el-button>
            </div>




        </div>
        <el-dialog title="提示" :visible.sync="captchaDialog" center :close-on-click-modal="false" :close-on-press-escape="false" width="400px">
            <div class="flex-row">
                <span class="captcha-lab w150px">验证码：</span>
                <el-input class="captcha-inp" v-model="captcha" maxlength="4" clearable placeholder="请输入右边验证码"></el-input>
                <img class="captcha-img w80px h30" :src="captchaUrl" alt="点我刷新" @click="refreshRanCode">
            </div>
            <span slot="footer">
                <el-button @click="captchaDialog=false">取 消</el-button>
                <el-button type="primary" @click="captchaVerification">确 定</el-button>
            </span>
        </el-dialog>

    </div>

</template>

<script>
    import apiConfig from "../../api/api.config";
    export default {
        data() {
            return {
                sms_code:'',
                second:60,
                showText:true,
                info:{type:1},
                code:'',
                fileList:[],
                captcha:'',
                captchaUrl: "",
                captchaStr: "",
                captchaDialog: false,
                userInfo:{}
            }
        },
        mounted() {
            var $this=this;
            setTimeout(function(){
                $this.getUserInfo();

            },200);
            $this.getCertification();

        },
        methods: {
            async submit(){
                var postdata=this.info;
                postdata['code']=this.code;
                const {ret,msg} = await this.$api.user.certification(postdata);
                if (ret === 1000){
                    this.$message.success("已提交！");
                    window.location.reload(1);
                } else{
                    this.$message.error(msg);
                }
            },
            async getUserInfo() {
                const {ret,data} = await this.$api.user.getUserInfo();
                if (ret === 1000){
                    this.userInfo = data;
                }
            },
            async getCertification() {
                const {ret,data} = await this.$api.user.getCertification();
                if (ret === 1000){
                    this.info = data;
                }
            },
            async captchaVerification() {
                const vCode = this.captcha;
                const time = parseInt((new Date().getTime())/1000);
                if (vCode === ""){
                    this.$message.error("请填写验证码！");
                    return;
                }
                let ph = this.info.mobile;
                let sg = this.$common.captchaSign(ph,vCode,time);
                let getData = {
                    ph: ph,
                    sg: sg,
                    code: vCode,
                    time: time,
                    unique_id: this.uniqueID,
                };
                const {ret,data} = await this.$api.captcha(getData);
                if (ret === 1000){
                    this.captchaStr = data.keys;
                    this.$cookies.set('captchaStr',data.keys);
                    this.captchaDialog = false;
                    this.sendCode();
                }else if (ret === 4005){
                    this.refreshRanCode();
                }


            },

            async refreshRanCode() {
                const baseUrl = apiConfig.baseUrl;
                const {ret,data} = await this.$api.getCode();
                if (ret === 1000){
                    this.uniqueID = data.id;
                    this.captchaUrl = baseUrl+data.url;
                }else {
                    this.$message.error('出错了！请刷新重试');
                }
            },

            async sendCode(){//倒计时
                console.log(this.info);
                const time = parseInt((new Date().getTime())/1000);
                if(!this.info.mobile){
                    this.$message.error("手机号码不能为空");
                    return;
                }
                if (this.captchaStr === "") {
                    this.refreshRanCode();
                    this.captchaDialog = true;
                    return;
                }

                this.showText = false
                var interval = setInterval(() => {
                    let times = --this.second
                    this.second = times<10?'0'+times:times //小于10秒补 0
                }, 1000)
                setTimeout(() => {
                    clearInterval(interval)
                    this.second=60
                    this.showText = true
                }, 60000)

                const captcha = this.$cookies.get('captchaStr');
                let postdata = {
                    phone: this.info.mobile,
                    captcha: captcha,
                    unique_id: this.uniqueID,
                };
                const {ret} = await this.$api.sendSms(postdata);
                if (ret === 1000){
                    this.$message.success("发送成功");
                }else {
                    console.log('send code error ...');
                }


            },
            upload_id(file){
                var $this=this;
                this.$common.Upload(file,function(img){
                    console.log(img);
                    $this.info['id_img']=img
                    $this.$forceUpdate();
                });
            },
            upload_cer(file){
                var $this=this
                this.$common.Upload(file,function(img){
                    console.log(img);
                    $this.info['license_img']=img
                    $this.$forceUpdate();
                });
            },


        }
    }
</script>

<style scoped>
input[type=text]{border:none;border-radius: 5px;padding:8px 10px;width:200px;border: 1px solid #ccc;background:#f1f1f1;}

</style>
